import React from 'react'
import AddNewConnectorBtn from '../AddNewConnectorBtn/AddNewConnectorBtn'
import { AddNewConnectorFormModal } from '../AddNewConnectorForm/AddNewConnectorFormPresenter'

export default function AddNewConnectorBtnModal({modalId = 'new-connector'}:{modalId?: string}) {

  return (
    <>
      <AddNewConnectorBtn modalId={modalId}/>
      <AddNewConnectorFormModal modaleId={modalId}/>
    </>
  )
}
